import React from 'react';
import GreenLeafApi from '../utils/GreenLeafApi';
import {Button, Col, DropdownButton, MenuItem, Modal, Panel, Row} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import FaPencil from 'react-icons/lib/fa/pencil';
import './TeamPage.css';
import ContactType from '../utils/ContactType';
import NotFoundPage from '../NotFoundPage';
import AssessmentsPanel from './AssessmentsPanel';
import {LinkContainer} from 'react-router-bootstrap';
import DevModal from './DevModal';
import CoachAssessmentModal from './CoachAssessmentModal';
import ErrorComponent from '../ErrorComponent';

const SHOW_DEV_BUTTON = process.env.REACT_APP_DEV_MODE === 'true' || process.env.NODE_ENV === 'development';

class TeamPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      team: {},
      company: {},
      owner: {},
      scrumMaster: {},
      program: {},
      loading: true,
      showOwner: false,
      showScrum: false,
      coachScores: [],
      groupScores: [],
      notAssessed: false,
      notFound: false,
      isGroupForm: false,
      form: {
        day: null,
        month: null,
        year: null,
        takers: null
      },
      showCoachAssessmentModal: false,
      showDevModal: false,
      error: []
    };

    this.fetchTeam = this.fetchTeam.bind(this);
    this.fetchCompany = this.fetchCompany.bind(this);
    this.fetchScores = this.fetchScores.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.getScrumMasterName = this.getScrumMasterName.bind(this);
    this.getProductOwnerName = this.getProductOwnerName.bind(this);
  }

  async componentDidMount() {
    try {
      let promises = [this.fetchTeam(), this.fetchCompany(), this.fetchScores()];
      await Promise.all(promises);
    } catch (e) {
      this.setState({error: e.errors});
    }
    this.setState({loading: false});
  }

  async fetchTeam() {
    const teams = (await GreenLeafApi.Team.get({teamId: this.props.match.params.teamId}));

    if (teams.data.length === 0) {
      this.setState({ notFound: true });
      return;
    }
    this.setState({team: teams.data[0]});

    const teamContacts = (await GreenLeafApi.TeamContact.get({teamId: this.props.match.params.teamId})).data;
    teamContacts.forEach(async teamContact => {
      const contact = (await GreenLeafApi.Contact.get({contactId: teamContact.contact_id})).data[0];
      switch (teamContact.type_id) {
        case ContactType.PRODUCT_OWNER:
          this.setState({owner: contact});
          break;
        case ContactType.SCRUM_MASTER:
          this.setState({scrumMaster: contact});
          break;
        default:
          console.error('Error assigning contact type.');
      }
    });

    const program = await GreenLeafApi.Program.get({programId: this.props.match.params.programId});
    this.setState({program: program.data[0]});
  }

  async fetchCompany() {
    const company = (await GreenLeafApi.Company.get({id: this.props.match.params.companyId}));
    this.setState({company: company.data[0]});
  }

  async fetchScores() {
    const coachScores = (await GreenLeafApi.TeamAssessment.getScore({team_id: this.props.match.params.teamId}));
    const groupScores = (await GreenLeafApi.GroupTeamAssessment.getScore({team_id: this.props.match.params.teamId}));
    const coachSubScores = (await GreenLeafApi.TeamAssessment.getSubScores({ team_id: this.props.match.params.teamId }));
    const groupSubScores = (await GreenLeafApi.GroupTeamAssessment.getSubScores({ team_id: this.props.match.params.teamId }));


    let scoreArr = coachScores.data.score;
    scoreArr.forEach(s => {

      s.subscores = coachSubScores.data.scores ? coachSubScores.data.scores.filter(ss => s.team_assessment_id === ss.team_assessment_id).map(ss => ({ subsection_id: ss.subsection_id, score: ss.score })) : [];
    });
    this.setState({coachScores: scoreArr});


    scoreArr = groupScores.data.score;
    scoreArr.forEach(s => {
      s.subscores = groupSubScores.data.scores ? groupSubScores.data.scores.filter(ss => s.group_team_assessment_id === ss.group_team_assessment_id).map(ss => ({ subsection_id: ss.subsection_id, score: ss.score })) : [];
    });
    this.setState({groupScores: scoreArr});


    if(coachScores.data.score.length === 0 && groupScores.data.score.length === 0) {
      this.setState({notAssessed: true});
    }
  }

  handleClose() {
    this.setState({ showOwner: false, showScrum: false});
  }

  handleShow(type) {
    switch (type) {
      case ContactType.SCRUM_MASTER:
        this.setState({ showScrum: true });
        break;
      case ContactType.PRODUCT_OWNER:
        this.setState({ showOwner: true });
        break;
      default:
        console.error('Invalid contact type supplied.');
    }
  }

  getProductOwnerName() {
    return this.state.owner.first_name ?
      this.state.owner.first_name + ' ' + this.state.owner.last_name : '';
  }

  getScrumMasterName() {
    return this.state.scrumMaster.first_name ?
      this.state.scrumMaster.first_name + ' ' + this.state.scrumMaster.last_name : '';
  }

  onHideCoachAssessmentModal = () => {
    this.setState({ showCoachAssessmentModal: false });
  };

  handleCoachAssessment = async () => {
    try {
      let answers = await GreenLeafApi.TeamAssessment.getLatestAssessmentAnswers(this.state.team.id);
      const continueAssessment = answers.data && answers.data.assessment.length > 0;

      if (continueAssessment) {
        this.props.history.push(`/companies/${this.props.match.params.companyId}/programs/${this.props.match.params.programId}/teams/${this.props.match.params.teamId}/assessment`);
      } else {
        this.setState({ showCoachAssessmentModal: true });
      }
    } catch (e) {
      this.setState({error: e.errors});
    }
  };

  render() {
    if(this.state.loading) {
      return <p>Loading...</p>;
    }

    if(this.state.notFound) {
      return <NotFoundPage/>;
    }

    return (
      <div>
        {
          this.state.error.length > 0 &&
            <ErrorComponent error={this.state.error}/>
        }


        <div className='flex-row-spaced'>
          <h2 data-cy="team-header" className='m0'>
            Team: &nbsp; {this.state.team.name}
          </h2>
          <div>
            <DropdownButton
              className="mr1"
              title="Assess Team"
              id="assess-team-dropdown"
              data-cy="assess-team-dropdown"
            >
              <MenuItem onClick={this.handleCoachAssessment} eventKey={1}>Coach Assessment</MenuItem>
              <LinkContainer data-cy='gen-group-assess'  to={{pathname: `/companies/${this.props.match.params.companyId}/programs/${this.props.match.params.programId}/teams/${this.props.match.params.teamId}/selfassessment/create`,
                  state: {subsection_ids: null}}}>
                <MenuItem eventKey={2}>Self Assessment</MenuItem>
              </LinkContainer>
            </DropdownButton>
            <Link to={`/companies/${this.props.match.params.companyId}/programs/${this.props.match.params.programId}/teams/${this.props.match.params.teamId}/edit`}>
              <Button data-cy="edit-team-button"><FaPencil /></Button>
            </Link>
          </div>
        </div>

        <AssessmentsPanel coachScores={this.state.coachScores} groupScores={this.state.groupScores} notAssessed={this.state.notAssessed} startDate={this.state.company.date_added}/>

        <Panel>
          <Panel.Heading>
            <Panel.Title componentClass="h3">Details</Panel.Title>
            </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col xs={2} className='ml1'>
                <h4 className='mb1'>Program: </h4>
                <h4 className='mb1'>Size: </h4>
                <h4 className='mb1'>Purpose: </h4>
                <h4 className='mb1'>Product Owner: </h4>
                <h4 className='mb1'>Scrum Master: </h4>
              </Col>
              <Col xs={3}>
                <h4 className='mb1' data-cy="team-program">{this.state.program.name}</h4>
                <h4 className='mb1' data-cy="team-size">{this.state.team.size} members</h4>
                <h4 className='mb1' data-cy="team-purpose">{this.state.team.purpose || 'N/A'}</h4>
                <h4 className='mb1'><a data-cy="product-owner" onClick={() => this.handleShow(ContactType.PRODUCT_OWNER)}>{ this.getProductOwnerName() }</a></h4>
                <h4 className='mb1'><a data-cy="scrum-master" onClick={() => this.handleShow(ContactType.SCRUM_MASTER)}>{this.getScrumMasterName()}</a></h4>
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
        {
          SHOW_DEV_BUTTON &&
          <Button style={{float: 'right'}} onClick={() => { this.setState({ showDevModal: true }); }}>Dev Options</Button>
        }

        <Modal show={this.state.showOwner} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.getProductOwnerName()}
              <Link
                className='pull-right pr1'
                to={`/companies/${this.props.match.params.companyId}/programs/${this.props.match.params.programId}/teams/${this.props.match.params.teamId}/edit#owner`}>
                <Button data-cy="change-owner" className='primary'>Change Owner</Button>
              </Link>
            </Modal.Title>

          </Modal.Header>
          <Modal.Body>
            <p data-cy="owner-email">Email: {this.state.owner.email}</p>
            {this.state.owner.phone && <p data-cy="owner-phone">Phone: {this.state.owner.phone}</p>}
          </Modal.Body>
        </Modal>

        <Modal show={this.state.showScrum} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.getScrumMasterName()}
              <Link
                className='pull-right pr1'
                to={`/companies/${this.props.match.params.companyId}/programs/${this.props.match.params.programId}/teams/${this.props.match.params.teamId}/edit#scrum`}>
                <Button data-cy="change-scrum-master" className='primary'>Change Scrum Master</Button>
              </Link>
            </Modal.Title>

          </Modal.Header>
          <Modal.Body>
            <p data-cy="scrum-master-email">Email: {this.state.scrumMaster.email}</p>
            {this.state.scrumMaster.phone && <p data-cy="scrum-master-phone">Phone: {this.state.scrumMaster.phone}</p>}
          </Modal.Body>
        </Modal>

        <CoachAssessmentModal
          show={this.state.showCoachAssessmentModal}
          onHide={this.onHideCoachAssessmentModal}
        />

        {
          SHOW_DEV_BUTTON &&
          <DevModal
            show={this.state.showDevModal}
            onHide={() => { this.setState({ showDevModal: false }); }}
          />
        }
      </div>
    );
  }
}

export default TeamPage;


// WEBPACK FOOTER //
// ./src/components/teams/TeamPage.js